import { GameSpotPlatform } from './gamespot-platform';
import './styles.scss';
import { createContainer } from '@wikia/ad-engine';

const container = createContainer();
const platform = container.get(GameSpotPlatform);

platform.execute();
